@if (service.isOpen()) {
<app-dynamic-modal-dialog [config]="service.config()!" (closeModal)="onDialogClose($event)"
  (cancelModal)="onDialogCancel($event)">
  <ng-template #dynamicContent></ng-template>
</app-dynamic-modal-dialog>
}